export default __webpack_public_path__ + "fb46ac5d39fc5349a87040d894083e56.svg";